import { ApolloClient, HttpLink, InMemoryCache, from } from '@apollo/client';
import fetch from 'cross-fetch';
import {
  SHOPIFY_GRAPHQL_ENDPOINT,
  SHOPIFY_GRAPHQL_ACCESS_TOKEN,
} from '../settings';

const httpLink = new HttpLink({
  uri: SHOPIFY_GRAPHQL_ENDPOINT,
  fetch,
  headers: {
    'X-Shopify-Storefront-Access-Token': SHOPIFY_GRAPHQL_ACCESS_TOKEN,
  },
});

const shopifyClient = new ApolloClient({
  cache: new InMemoryCache(),
  link: from([httpLink]),
});

export default shopifyClient;
